import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { useMe } from "../hooks/useMe";
import { NotFound } from "../pages/404";
import { Home } from "../pages/home";
import { UserRole } from "../__generated__/globalTypes";
import { SideBar } from "../components/side-bar";
import { PlayBar } from "../components/play-bar";
import { Subscriptions } from "../pages/subscriptions";
import { Category } from "../pages/category";
import { Profile } from "../pages/profile";
import { Search } from "../pages/search";
import { CreatePodcast } from "../pages/create-podcast";
import { ManagePodcasts } from "../pages/manage-podcasts";
import { ManagePodcast } from "../pages/manage-podcast";
import { EditEpisode } from "../pages/edit-episode";
import { CreateEpisode } from "../pages/create-episode";
import { EditPodcast } from "../pages/edit-podcast";
import { Podcast } from "../pages/podcast";
import { WriteReview } from "../pages/write-review";
import { EditProfile } from "../pages/edit-profile";

export const LoggedInRouter = () => {
  const { data, loading, error } = useMe();

  const HostRoutes = [
    <Route key={1} path="/create-podcast" exact>
      <CreatePodcast />
    </Route>,
    <Route key={2} path="/manage-podcasts" exact>
      <ManagePodcasts />
    </Route>,
    <Route key={3} path="/manage-podcast/:id" exact>
      <ManagePodcast />
    </Route>,
    <Route key={4} path="/podcast/:podcastId/edit-episode/:episodeId" exact>
      <EditEpisode />
    </Route>,
    <Route key={5} path="/podcast/:podcastId/create-episode" exact>
      <CreateEpisode />
    </Route>,
    <Route key={6} path="/podcast/:podcastId/edit" exact>
      <EditPodcast />
    </Route>,
  ];

  if (!data || loading || error) {
    return (
      <div className="h-screen flex items-center flex-col justify-center bg-gray-900 text-white">
        <FontAwesomeIcon icon={faSpinner} spin className="text-2xl" />
      </div>
    );
  }

  return (
    <Router>
      <SideBar />

      <div className=" overflow-scroll h-screen">
        <PlayBar />
        <Switch>
          <Route path="/home" exact>
            <Home />
          </Route>
          <Route path="/subscriptions" exact>
            <Subscriptions />
          </Route>
          <Route path="/category" exact>
            <Category />
          </Route>
          <Route path="/profile" exact>
            <Profile />
          </Route>
          <Route path="/search" exact>
            <Search />
          </Route>
          <Route path="/podcast/:id" exact>
            <Podcast />
          </Route>
          <Route path="/podcast/:id/write-review" exact>
            <WriteReview />
          </Route>
          <Route path="/edit-profile" exact>
            <EditProfile />
          </Route>
          {data.me.role === UserRole.Host && HostRoutes}
          <Route>
            <NotFound />
          </Route>
        </Switch>
      </div>
    </Router>
  );
};
